export const handleHoverStateFor = (flexyInstance) => {
  const sliderContainer = flexyInstance.sliderContainer

  if (!flexyInstance.options.autoplay) return

  const pauseAutoPlay = () => {
    if (!flexyInstance.state.sliderActivated) {
      return
    }

    flexyInstance.options = {
      ...flexyInstance.options,
      autoplay: false,
      _autoplay: flexyInstance.options.autoplay,
    }
  }

  const resumeAutoPlay = () => {
    if (!flexyInstance.state.sliderActivated) {
      return
    }

    flexyInstance.options = {
      ...flexyInstance.options,
      autoplay: flexyInstance.options._autoplay,
      _autoplay: false,
    }

    flexyInstance.state = {
      ...flexyInstance.state,
      lastTimeAnimated: new Date().getTime(),
    }
  }

  sliderContainer.addEventListener("mouseenter", pauseAutoPlay)
  sliderContainer.addEventListener("mouseleave", resumeAutoPlay)

  const intersectionObserver = new IntersectionObserver((entries) => {
    entries.map(({ target: el, isIntersecting, intersectionRatio }) => {
      if (isIntersecting) {
        if (!Object.keys(flexyInstance.options).includes("_autoplay")) {
          return
        }
        resumeAutoPlay()
      }

      if (!isIntersecting) {
        pauseAutoPlay()
      }
    })
  }, {})

  intersectionObserver.observe(sliderContainer)
}
